const load = url => {
  return new Promise((resolve, reject) => {
    const finalUrl = new URL(url);
    const img = new Image();
    
    finalUrl.searchParams.append('ts', Date.now());
    img.onload = () => {
      resolve(img);
    };
    img.onerror = reject;
    img.crossOrigin = 'anonymous';
    img.src = finalUrl.toString();
  });
};

const crop = imageElement => {
  const imageWidth = imageElement.naturalWidth;
  const imageHeight = imageElement.naturalHeight;
  const canvas = document.createElement('canvas');
  canvas.width = 224;
  canvas.height = 224;
  const ctx = canvas.getContext('2d');
  let posx = 0;
  let posy = 0;
  const size = Math.min(imageWidth, imageHeight);
  if (imageHeight > imageWidth) {
    posy = (imageHeight - imageWidth) / 2;
  }
  if (imageWidth > imageHeight) {
    posx = (imageWidth - imageHeight) / 2;
  }
  /* 
    1. Scale image width/height to 224px
    2. Center image in canvas
  */
  ctx.drawImage(imageElement, posx, posy, size, size, 0, 0, 224, 224);
  return canvas.toDataURL();
};

const readData = (mode, file) => {
  return new Promise(resolve => {
    const fileReader = new FileReader();
    fileReader.onload = resolve;
    fileReader[mode](file);
  });
};

const readOrientation = async file => {
  const event = await readData('readAsArrayBuffer', file);
  const view = new DataView(event.target.result);
  const length = view.byteLength;
  let offset = 2;

  if (view.getUint16(0, false) != 0xFFD8) return -2;
  while (offset < length) {
    let marker = view.getUint16(offset, false);
    offset += 2;
    if (marker == 0xFFE1) {
      if (view.getUint32(offset += 2, false) != 0x45786966) return -1;
      const little = view.getUint16(offset += 6, false) == 0x4949;
      offset += view.getUint32(offset + 4, little);
      const tags = view.getUint16(offset, little);
      offset += 2;
      for (var i = 0; i < tags; i++) {
        if (view.getUint16(offset + (i * 12), little) == 0x0112) {
          return view.getUint16(offset + (i * 12) + 8, little);
        }
      }
    }
    else if ((marker & 0xFF00) != 0xFF00) break;
    else offset += view.getUint16(offset, false);
  }
  return -1;
};

const correctOrientation = async file => {
  const event = await readData('readAsDataURL', file);
  const srcBase64 = event.target.result;
  const orientation = await readOrientation(file);

  return new Promise(resolve => {
    const img = new Image();
    img.onload = () => {
      const width = img.width;
      const height = img.height;
      const canvas = document.createElement('canvas');
      const ctx = canvas.getContext('2d');

      if (4 < orientation && orientation < 9) {
        canvas.width = height;
        canvas.height = width;
      } else {
        canvas.width = width;
        canvas.height = height;
      }
      switch (orientation) {
        case 2: ctx.transform(-1, 0, 0, 1, width, 0); break;
        case 3: ctx.transform(-1, 0, 0, -1, width, height); break;
        case 4: ctx.transform(1, 0, 0, -1, 0, height); break;
        case 5: ctx.transform(0, 1, 1, 0, 0, 0); break;
        case 6: ctx.transform(0, 1, -1, 0, height, 0); break;
        case 7: ctx.transform(0, -1, -1, 0, height, width); break;
        case 8: ctx.transform(0, -1, 1, 0, 0, width); break;
        default: break;
      }
      ctx.drawImage(img, 0, 0);
      resolve(canvas.toDataURL());
    };
    img.src = srcBase64;
  });
};

const rotate = (element, degree) => {
  const canvas = document.createElement('canvas');
  const ctx = canvas.getContext('2d');

  /* Support Image or Video */
  canvas.width = element.naturalWidth || element.videoWidth;
  canvas.height = element.naturalHeight || element.videoHeight;

  ctx.setTransform(1, 0, 0, 1, 0, 0);
  ctx.clearRect(0, 0, canvas.width, canvas.height);
  ctx.translate(canvas.width * 0.5, canvas.height * 0.5);
  ctx.rotate(degree * Math.PI / 180);
  ctx.translate(-canvas.width * 0.5, -canvas.height * 0.5);
  ctx.drawImage(element, 0, 0, canvas.width, canvas.height);

  return canvas;
}

export default {
  load,
  crop,
  rotate,
  correctOrientation
};
